export default class URLParameter {
  constructor(public paramName: string, public paramValue: string) {

  }
}
